import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery'
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import StaffPage from '../../views/StaffPage/';
import Sanitize from '../../Sanitize';
const GLOBAL = require('../../Globals');

class EmpAttendanceView extends Component {
	
	constructor(props){
		super(props);
		this.state = {
			id : '',
			acyear : '',
			dept : '',
			year : '',
			month : '',
			attdate : moment(),
			_message : '',
			alertClass :'',
			depart : [],
			emp : [],
			data : [],
			accyear : [],
			_redirect : false,
			chk : '',
			att : [],
			remark : [],
			events : []
		}
		
		this.onChange = this.onChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}
	
	/** set value to Attendance datepicker **/
	handleChange(date) {
		this.setState({
		  attdate: date
		});
	}
	
	onChange(e){
		
		this.setState({[e.target.name]:e.target.value});
		var today = new Date();
		/* console.log('date '+today);
		console.log(this.state); */
		this.getemployee();
		this.getdata();
		this.daysInMonth();
		this.getleave();
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdepartment();
		this.getacyear();
	}
	
	/** get Leave Days **/
	getleave(){
		
		GetData('student/getleave').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					events : responseJson
				});
			}
		});
	}
	
	/** get Department **/
	getdepartment(){
		$("#showLoader").show();
		GetData('department/getdepartment').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					depart : responseJson
				});
			}
		});
	}
	
	/** Get Academic Year **/
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
			}
		});
	}
	
	/** get Employee **/
	getemployee(){
		var ac = $("#year").val();
		var cs = $("#depart").val();
		$("#showLoader").show();
		GetData('employee/getempbydept/'+cs).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					emp : responseJson
				});
			}
		});
	}
	
	getdata(){
		var ac = $("#year").val();
		// var cs = $("#depart").val();
		var sy = $("#syear").val();
		var mn = $("#month").val();
		$("#showLoader").show();
		GetData('employee/getattendance/'+ac+'/'+sy+'/'+mn).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	getabsent(empid){
		
		var ab = [];
		
		var month = $("#month").val();
		var year = $("#syear").val();
		
		for(var i=1; i<this.daysInMonth(); i++){
			
			if(this.checksunday(i)){
						
				ab.push(<td id="sunback"><span id="attsun" ><b style={{ color: '#f86c6b' }}>S</b></span></td>);
			}
			else{
				
				if(this.chkevents(i,month,year)){
					
					ab.push(<td><span id="attpre"><b style={{ color: '#ffc107' }}>H</b></span></td>);
							
				}
				else{
						
					if(this.getcurdate(i)){
						
						if(this.checkabsent(empid,i)){
							
							ab.push(this.checkonduty(empid,i));
						}
						else{
							
							ab.push(<td><span id="attpre" ><b style={{ color: '#4dbd74' }}>X</b></span></td>);
						}
					}
					else{
						ab.push(<td></td>);
					}
				}
			}
		
		}
		
		return ab;
		
	}
	
	getcurdate(date){
		var bstate = false;
		var month = $("#month").val();
		var year = $("#syear").val();
		var newDate = new Date(''+year+'-'+month+'-'+this.addzero(date)).getTime();
		var today = new Date().getTime();
		
		if(newDate <= today){
			
			bstate = true;
		}
		else{
			
			bstate = false;
		}
		return bstate;
	}
	
	//Check Leave
	chkevents(date,month,year){
		
		var newDate = year+'-'+month+'-'+this.addzero(date);
		var dfsadg = new Date(newDate).getTime();
		
		var bstate=false;
		if(year >0 && month >0 && date >0){
			for(var j=0; j < this.state.events.length; j++){
				
				var s1 = new Date(this.state.events[j].start).getTime();
				var e1 = new Date(this.state.events[j].end).getTime();
				
				if( dfsadg >= s1 &&  dfsadg < e1){
					bstate=true;
					break;
				}
				else{
					
					bstate= false;
				}
							
			}
		}
		return bstate;
		
	}
	
	addzero(day){
		var temp = ''+day;
		if(temp.length == 1){
			
			temp = "0"+temp;
			return temp;
		}
		else{
			
			return temp;
		}
		
	}
	
	checkabsent(empid,day){
		
		var boolstate=false;
		for(var ii=0; ii < this.state.data.length; ii++){
			
			if(this.state.data[ii].employee == empid && this.state.data[ii].day == this.addzero(day)){
				
				boolstate=true;
				break;
			}
			else{
				boolstate= false;
			}
						
		}
		return boolstate;
	}
	
	checkonduty(empid,day){
		
		var boolstate = [];
		for(var ii=0; ii < this.state.data.length; ii++){
			
			if(this.state.data[ii].employee == empid && this.state.data[ii].day == this.addzero(day) && this.state.data[ii].remark==0){
				
				boolstate.push(<td><span id="abs"><b style={{ color: 'red' }}>A</b></span></td>);
				break;
			}
			else if(this.state.data[ii].employee == empid && this.state.data[ii].day == this.addzero(day) && this.state.data[ii].remark!=0){
				boolstate.push(<td><span id="abs" className="text-default"><b>{this.state.data[ii].remark}</b></span></td>);
				break;
			}
						
		}
		return boolstate;
	}
	
	getdays(){
		var days = [];
		
		for(var i=1; i<this.daysInMonth(); i++){
			
			days.push(<td>{i}</td>);
		}
		
		return days;
	}
	
	checksunday(dat){
		var bstate=false;
		var month = $("#month").val();
		var year = $("#syear").val();
		
		var newDate = new Date(''+year+'-'+month+'-'+dat);
		// console.log('date '+newDate);
		if(newDate.getDay()==0){   //if Sunday
			bstate=true;
		}
		else{  //if Saturday
			bstate= false;
		}
		return bstate;
	}
	
	daysInMonth() {
		
		var month = $("#month").val();
		var year = $("#syear").val();
		var ndays = new Date(year, month, 0).getDate();
		return ndays+1;
	}
	
	getdept(id){
		var d = this.state.depart;
		
		if(id == 'all'){
			return 'All';
		}
		else{
			
			var index = d.findIndex(function(obj){
				return(obj.id == id);
			});
			if(index > -1){
				return d[index].department;
			}
		}
	}
	
	render() {
		
		/** get year only select box **/
		const currentYear = new Date().getFullYear();
		const fromMonth = new Date(currentYear - 1, 0);
		const toMonth = new Date(currentYear + 10, 11);
		
		const years = [];
		  for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
			years.push(i);
		}
	
		var dept = this.state.depart;
		var acyear = this.state.accyear;
		
		if(this.state.acyear!='' && this.state.dept!='' && this.state.year!='' && this.state.month!=''){
			
			$("#attab").show();
		}
		else{
			
			$("#attab").hide();
		}
		
		$('.selectall').click(function() {
			if ($(this).is(':checked')) {
				$('table input').attr('checked', true);
			} else {
				$('table input').attr('checked', false);
			}
		});
		
		/** set month in select box **/
		  this.month = [
			{value : '', name: 'Select Month'},
			{value : '01', name: 'January'},
			{value : '02', name: 'February'},
			{value : '03', name: 'March'},
			{value : '04', name: 'April'},
			{value : '05', name: 'May'},
			{value : '06', name: 'June'},
			{value : '07', name: 'July'},
			{value : '08', name: 'August'},
			{value : '09', name: 'September'},
			{value : '10', name: 'October'},
			{value : '11', name: 'November'},
			{value : '12', name: 'December'}
		];
	
	return (
		<div>
		  <StaffPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			  <form action="" method="post" role="form" id="attform" encType="multipart/form-data" onSubmit={this.onSubmit} >
				<Row>
				  <Col md="12">
					<Card>
						<CardHeader>
							<strong>View Attendance</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onChange} required id="year">
								<option value="">Select</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							</select>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Department <span className="text-danger">*</span></Label>
								  <select name="dept" onChange={this.onChange} className="form-control" required id="depart">
									<option value="">Select Department</option>
									<option value="all">All</option>
									{
										dept.map(function (item) {
											return <option value={item.id }>{item.department}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="2">
								<FormGroup>
								  <Label htmlFor="name">Year</Label>
								  <select name="year" className="form-control" onChange={this.onChange} required id="syear">
									<option value="">Select Year</option>
									{years.map(year => (
									  <option key={year} value={year}>
										{year}
									  </option>
									))}
								  </select>
								</FormGroup>
							  </Col>
							   <Col md="2">
								<FormGroup>
								  <Label htmlFor="name">Month <span className="text-danger">*</span></Label>
								  <select name="month" className="form-control" onChange={this.onChange} required id="month">
									{this.month.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}		
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="2" style={{marginTop : '30px'}}>
								<FormGroup>
									<ReactHTMLTableToExcel
									id="test-table-xls-button"
									className="download-table-xls-button btn-success"
									table="atttable"
									filename={this.getdept(this.state.dept) + ' - ' +Sanitize.getMonthName(this.state.month)+' '+this.state.year}
									sheet="Attendance Report"
									buttonText="Excel Export" />
								</FormGroup>
							</Col>
							</Row>
							<Row id="attab">
							  <Col md="12">
								<Table responsive bordered id="atttable">
								  <thead>
									<tr>
										<td>#</td>
										{this.getdays()}
									</tr>
								  </thead>
								  <tbody>
									{this.state.emp.map((item,index) =>
								 
										<tr key = {index}>
											<td id="subtext">{item.empname}</td>
											{this.getabsent(item.id)}
										</tr>
									)}
								  </tbody>
								</Table>
							  </Col>
							</Row>
						</CardBody>
					</Card>
				  </Col>
				</Row>
			  </form>
			</div>
		</div>
	)
  }
}

export default EmpAttendanceView;


// WEBPACK FOOTER //
// ./src/employee/Attendance/EmpAttendanceView.js